import { ReactNode, useState } from 'react'

import { Text } from '@hhgtech/hhg-components'

import { ExpandedCard } from 'components/molecules/expandedCard'
import { assetImagePath } from 'interfaces/constants'

import {
  StyledOvulationImageIcon,
  StyledInfoContentWrapper,
} from './index.styled'

export type InfoType = {
  title: string
  description: string
}

export type Props = {
  heading?: string
  content?: ReactNode
  infos?: InfoType[]
  className?: string
}

const OvulationInfo = ({ heading, infos, content, className }: Props) => {
  const [openInfo, setOpenInfo] = useState(-1)
  return (
    <div id="calculator-info" className={className}>
      <Text
        size="base"
        type="bold"
        color="#8C8C8C"
        style={{
          margin: '1rem 0',
        }}
      >
        <StyledOvulationImageIcon src={`${assetImagePath}/info-icon.svg`} />
        {heading}
      </Text>
      {content ? (
        <StyledInfoContentWrapper>
          <Text size="p2" style={{ lineHeight: '1.5' }}>
            {content}
          </Text>
        </StyledInfoContentWrapper>
      ) : null}
      {infos?.map((info, index) => (
        <ExpandedCard
          key={index}
          title={info.title}
          isExpand={openInfo === index}
          onChange={(value: boolean) =>
            value ? setOpenInfo(index) : setOpenInfo(-1)
          }
          contentString={info.description}
          iconPosition="right"
          style={{
            marginBottom: '1rem',
          }}
        />
      ))}
    </div>
  )
}

export { OvulationInfo }
